import { openNotification } from './mantine-notification-helper';
import { IGetCartProduct } from '@/interfaces/cart';
import { DeliveryType } from '@/enums';


interface IProcessCouponParam {
  res: IGetCartProduct;
  setRedeemedCoupon: Function | undefined;
  setShowRemoveOption: Function | undefined;
  setLoading: Function | undefined;
  setCoupon?: Function;
}

export function processCoupon({ res, setRedeemedCoupon, setShowRemoveOption, setLoading, setCoupon }: IProcessCouponParam) {
  const warnings = res.Warnings || [];
  let hasWarning = warnings.length > 0;
 let warningMessage = warnings.join(', ');

  if (warningMessage && warningMessage.at(-1) !== '.') {
    warningMessage += '.';
  }

  if (!res.IsPhoneNumberRequired && hasWarning) {
    setRedeemedCoupon?.('');
    setCoupon?.('');
    setShowRemoveOption?.(false);
    openNotification('danger', 'Coupon', warningMessage);
  } else if (res.IsPhoneNumberRequired && hasWarning) {
    openNotification('danger', 'Coupon', warningMessage);
    setShowRemoveOption?.(false);
  } else {

    openNotification('success', 'Coupon', 'Your Coupon has been successfully redeemed');
    setShowRemoveOption?.(true);
  }
  setLoading?.(false);
}


   export const checkUnavailableSelectedVariations = (cartData: IGetCartProduct, deliveryType: string) => {
  if(deliveryType !== DeliveryType.ExpressDelivery && deliveryType !== DeliveryType.PickFromStore) return false;
  
  if (!cartData.HasCartMixItem) {
    return false;
  }

  if (!cartData.Items || cartData.Items.length === 0) {
    return false;
  }

  for (const item of cartData.Items) {
    if (!item.Variations || item.Variations.length === 0) {
      return false;
    }

    const allVariationsUnavailable = item.Variations.every((variation) => {
      return variation.IsAvailableInProvidedStores === false && variation.IsSelected === true && cartData.Warnings?.length>0;
    });

    if (!allVariationsUnavailable) {
      return false;
    }
  }

  return true;
};

 export const checkUnavailableSelectedVariationsInPayment = (cartData: IGetCartProduct) => {
  
  if (!cartData?.Items || cartData?.Items?.length === 0) {
    return false;
  }

  for (const item of cartData?.Items ?? []) {
    if (!item?.Variations || item?.Variations?.length === 0) {
      return false;
    }

    const allVariationsUnavailable = item?.Variations.every((variation) => {
      return variation?.IsAvailableInProvidedStores === false && variation?.IsSelected === true;
    });

    if (!allVariationsUnavailable) {
      return false;
    }
  }

  return true;
};

export const checkGuestCheckoutButton = (cartData: IGetCartProduct, showExpressOption: boolean, showPickInStoreOption:boolean) => {
  if(!showExpressOption && !showPickInStoreOption)
  {
    return false
  }
  
  if (!cartData?.Items?.length) {
    return false;
  }

  return cartData.Items.some(item => 
    item?.Variations?.some(variation => 
      variation?.IsSelected === true && variation?.IsAvailableInProvidedStores === true
    )
  );
};

// Helper functions defined outside component
export const checkExpressDelivery = (isExpressEnabled: boolean, orderSummaryData: any, selectedStoreIds: string[]) => {
  return isExpressEnabled && orderSummaryData?.IsGiftVoucher === false && selectedStoreIds.length > 0;
};

export const checkBopisDelivery = (showPickInStoreOption: boolean, selectedStore: any) => {
  return showPickInStoreOption && selectedStore?.Id !== undefined;
};

export const checkHideDeliveryCost = (
  isExpressEnabled: boolean, 
  selectedStoreIds: string[], 
  orderSummaryData: any, 
  selectedStore: any
) => {
  const hasExpressDelivery = isExpressEnabled && selectedStoreIds.length > 0;
  const hasStorePickup = selectedStore?.Id !== undefined;
  
  if (hasExpressDelivery && orderSummaryData?.DeliveryCharge === 0) return true;
  if (hasStorePickup && orderSummaryData?.DeliveryCharge === 0) return true;
  
  return false;
};


export const getOrderType = (shippingOption: string | undefined) => {
  // If no shipping option is selected, return undefined
  if (shippingOption === undefined) {
    return undefined;
  }
  
  // Express delivery
  if (shippingOption === DeliveryType.ExpressDelivery) {
    return 10;
  }
  
  // Pick from store
  if (shippingOption === DeliveryType.PickFromStore) {
    return 5;
  }
  
  // Regular delivery (default)
  return 1;
};


export const getSearchQuery = (value: string, minLength: number) => {
  return value?.length > minLength ? value : '';
};

export const getValidId = (id: string) => id === '-1' ? undefined : id;

